<template>
    <div>
        <!-- import state reps -->
        <app-state-reps v-if="stateRepCheck"></app-state-reps>
        
        <!-- import marketers -->
        <app-marketers v-if="marketerCheck"></app-marketers>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import LayoutUser from '@/layouts/User.vue'
import StateReps from './portalParts/StateReps.vue'
import Marketers from './portalParts/Marketers.vue'

export default {
    name: "Portal",
    computed: {
        ...mapGetters(['user']),
        marketerCheck() {
            if(this.user && this.user.roles){
                let userRoles = this.user.roles
                let portalRoles = ["referrer"]
                // js some() fxn returns true if some of the elements in array one exists in array two
                let rolesCheck = userRoles.some((val) => portalRoles.indexOf(val) !== -1);  
                if(rolesCheck !== false){
                    return true
                }
            }
            return false
        },
        stateRepCheck() {
            if(this.user && this.user.roles){
                let userRoles = this.user.roles
                let portalRoles = ["state-rep"]
                // js some() fxn returns true if some of the el in arry one exists in array two
                let rolesCheck = userRoles.some((val) => portalRoles.indexOf(val) !== -1);  
                if(rolesCheck !== false){
                    return true
                }
            }
            return false
        }
    },
    components: {
        appStateReps: StateReps,
        appMarketers: Marketers
    },
    created() {
        this.$emit('update:layout', LayoutUser);
    }
}
</script>